import { List, ModelBase, NeoModel } from '@singularsystems/neo-core';
import ClientTestEmailLookup from '../ClientTestEmailLookup';

@NeoModel
export default class TestEmailsSaveCommand extends ModelBase {
   
    public clientId : number = 0;
  
    public clientTestEmails : List<ClientTestEmailLookup> = new List(ClientTestEmailLookup)
}